/**
 * Corrected ACL map type for the IssuePermissions API.
 * The generated IssuePermissions.acl is typed as 'edit' | 'view' (string union)
 * but the actual runtime shape is a map of bucket keys to identity arrays.
 */
export interface IssueAclMap {
  edit?: string[];
  view?: string[];
}

export type IssueAccessBucket = 'edit' | 'view';

export const ISSUE_ACCESS_BUCKETS: readonly IssueAccessBucket[] = [
  'edit',
  'view',
];

export const MAX_ISSUE_ACL_IDENTITIES = 100;

export const PERMISSION_CONSTANTS = {
  USER_PREFIX: 'users:',
  GROUP_PREFIX: 'tc-groups:',
  ALL_PROJECT_MEMBERS_ID: 'tc-groups:*',
  ALL_PROJECT_MEMBERS_WILDCARD: '*',
} as const;

export interface IPermissionEntry {
  readonly identity: string;
  readonly displayName: string;
  readonly accessLevel: IssueAccessBucket;
  readonly isInherited: boolean;
  readonly isMixed?: boolean;
  readonly avatarInitials: string;
  readonly isGroup: boolean;
}
